import { HyperText } from "@/components/magicui/hyper-text";
 
export function HyperTextDemo() {
  return <HyperText>Hover Me!</HyperText>;
}